module.exports = __webpack_public_path__ + "static/media/wall-street.dd371044.svg";